import {
  authencateAPI,
  saveAuthInformation,
} from "services/api/authAPI";
import {
  loggedIn,
  loggedInFailed,
  loggedOut,
} from "./authSlice";

export const signin = (formData) => async (dispatch) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const returnTo = params.get("returnTo");

  try {
    const userData = await authencateAPI(formData);
    if (!userData?.success) {
      dispatch(loggedInFailed());
      return userData?.message
        ? userData.message
        : "Error en la autenticación, por favor revise sus credenciales.";
    }
    dispatch(loggedIn(userData.data));
    saveAuthInformation(userData.data);
    //console.log(userData.data);
    const userLastChangePassword = new Date(userData.data?.last_change_password);
    const referenceDate = new Date('2024-09-20T00:00:00'); // Fecha de referencia

    if (userLastChangePassword > referenceDate) {
      if (returnTo) {
        window.location.href = `${returnTo}`;
      } else {
        window.location.href = "/";
      }
    }
    else {
      window.location.href = "/update_password";
    }
  } catch (error) {
    dispatch(loggedInFailed());
    return error.response && error.response.data.message
      ? error.response.data.message
      : error.message;
  }
};

export const singout = () => async (dispatch) => {
  localStorage.removeItem("gl-admin-authInfo");
  localStorage.removeItem("gl-admin-refreshTokenGlifos");
  localStorage.removeItem("gl-admin-accessTokenGlifos");
  dispatch(loggedOut());
};
